<template>
  <Modal
    :show="show"
    @close="$emit('close')"
    :allowOverflow="true"
    size="modal-xs"
    :noPad="true"
  >
    <template v-slot:body>
      <div class="ds-text-xl font-bold text-gray-1000 text-center mb-4">
        {{ headerText }}
      </div>

      <div class="flex flex-col items-center text-center">
        <img :src="imageUrl" class="mb-4" style="max-width: 233px" />

        <div class="ds-text-base text-gray-900 mb-4">
          <template v-if="motivation === 'message'">
            Sending messages to college coaches is a Pro feature.
            <template v-if="isExpiredUser"
              >Reactivate Pro to unlock the messaging system.</template
            >

            <template v-else-if="isFreeUser"
              >Upgrade today to get access to every college coach and see who's
              viewing your profile!</template
            >

            <template v-else
              >Upgrade today to unlock the messaging system.</template
            >
          </template>

          <template v-else>
            <template v-if="isExpiredUser"
              >Reactivate Pro to get access to every college
              coach.</template
            >

            <template v-else-if="isFreeUser">
              <template v-if="motivation === 'views'"
                >Seeing College Coach views is a Pro feature. Upgrade today
                to unlock your views and see who is viewing your profile, video
                and more.</template
              >
              <template v-else
                >Upgrade today to get access to every college coach.</template
              >
            </template>

            <template v-else>
              <template v-if="motivation === 'views'"
                >Seeing College Coach views is a Pro feature. Upgrade today
                to unlock your views and see who is viewing your profile, video
                and more.</template
              >
              <template v-else
                >Complete your verification checklist and let college coaches
                know you are committed to your recruiting efforts!</template
              >
            </template>
          </template>
        </div>

        <Button :text="buttonText" @click="onButtonClick()" />
      </div>
    </template>
  </Modal>
</template>

<script>
import api from "@/services/api";
import { Button, Modal } from "@sportsrecruits/playbook";
import trackVerificationCta from "@/utils/trackVerificationCta";
import FreeAthleteModal from "@/components/FreeAthleteModal";
export default {
  extends: FreeAthleteModal,
  components: {
    Modal,
    Button,
  },

  computed: {
    isExpiredUser() {
      return !!api.clientData("user_is_expired");
    },
    
    isFreeUser() {
      return api.clientData("user_is_free");
    },

    imageUrl() {
      return this.motivation === "message"
        ? "https://cdn.sportsrecruits.com/assets/messaging_half.gif"
        : "https://cdn.sportsrecruits.com/assets/itg/college-view-notification-in-phone.gif"
    },

    headerText() {
      switch (this.motivation) {
        case "views":
          return "Want to see who's trying to recruit you?";
        default:
          return "Want to reach out to college coaches?";
      }
    },

    buttonText() {
      return this.isExpiredUser
        ? "Reactivate Pro"
        : this.isFreeUser
        ? "Upgrade Account"
        : "Complete Verification";
    },

    buttonUrl() {
      return "/pricing";
    },
  },

  methods: {
    onButtonClick() {
      trackVerificationCta((this.cta && this.cta.name) || null);

      window.location.href = this.buttonUrl;
    },
  },
};
</script>
